export const BannerZone = ({
  broadstreetZone,
}: {
  broadstreetZone: { id: number | string; keywords: string };
}) => {
  return (
    <div
      id={`broadstreet-banner-${broadstreetZone?.id}`}
      className="srp__bs-banner"
      dangerouslySetInnerHTML={{
        __html: `<banner-zone zone-id='${broadstreetZone?.id}' keywords='${broadstreetZone?.keywords}'></banner-zone>`,
      }}
    />
  );
};

export default BannerZone;
